export function useClipboard() {
  const copy = async (text) => {
    if (!text) {
      return false
    }

    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (error) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      const ok = document.execCommand('copy')
      document.body.removeChild(textarea)
      return ok
    }
  }

  return { copy }
}
